<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="dataFiltered"
        :fields="fields"
        name="reporteMatricula.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
      <v-card>
        <v-card-title primary-title>
          Reportes Pagos de Aliados
        </v-card-title>
        <v-card-title>
          <v-layout row>
            <v-flex mr-3 xs12 md3>
              <v-select
                :items="enrollments"
                v-model="filter_enrollment"
                label="Matricula"
                item-text="description"
                item-value="id"
                clearable
              ></v-select>
            </v-flex>
            <v-flex mr-3 xs12 md3>
              <v-select
                :items="allies"
                v-model="filter_ally"
                label="Aliado"
                item-text="name"
                item-value="id"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

         <v-data-table
            :headers="headers"
            :items="dataFiltered"
            :search="search"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.enrollment }}</td>
                <td class="text-xs-center">{{ props.item.ally }}</td>
                <td class="text-xs-center">{{ props.item.cost }}</td>
                <td class="text-xs-center">{{ props.item.student }}</td>
                <td class="text-xs-center">{{ props.item.family_id }}</td>
                <td class="text-xs-center">{{ props.item.payment_type }}</td>
                <td class="text-xs-center">{{ props.item.payment_state }}</td>
                <td class="text-xs-center">{{ props.item.total }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
      </v-card>

    </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'allies-payments-report',
    components: {
      'download-excel': JsonExcel,
  },
    data() {
      return {
        allies: [],
        enrollments: [],
        filter_ally: '',
        filter_enrollment: '',
        headers: [
          { text: 'Matricula', align: 'center', value: 'enrollment' },
          { text: 'Aliado', align: 'center', value: 'ally' },
          { text: 'Descripcion Costo', align: 'center', value: 'cost' },
          { text: 'Estudiante', align: 'center', value: 'student' },
          { text: 'ID Familia', align: 'center', value: 'family_id' },
          { text: 'Tipo Pago', align: 'center', value: 'payment_type' },
          { text: 'Estado Pago', align: 'center', value: 'payment_state' },
          { text: 'Total', align: 'center', value: 'total' },
        ],
        fields: {
          'Matricula': 'enrollment',
          'Aliado': 'ally',
          'Descripcion Costo': 'cost',
          'Estudiante': 'student',
          'ID Familia': 'family_id',
          'Tipo Pago': 'payment_type',
          'Estado Pago': 'payment_state',
          'Total': 'total',
        },
        search: '',
        loading: false,
        data: [],
      }
    },
    created () {
      this.init();
    },
    computed: {
      dataFiltered() {
        let dataToFilter = this.data;
        if (this.filter_enrollment && this.filter_enrollment !== '') {
          dataToFilter = dataToFilter.filter(data => data.id_enrollment == this.filter_enrollment)
        }
        if (this.filter_ally && this.filter_ally !== '') {
          dataToFilter = dataToFilter.filter(data => data.id_ally == this.filter_ally)
        }
        return dataToFilter
      }
    },
    methods: {
      init() {
        axios.get('/api/enrollments/allyCosts/payments/report')
          .then(result => {
            if (result.status === 200) {
              this.data = result.data.data
            }
          })
        axios.get('/api/enrollments/allies')
          .then(result => {
            if (result.status === 200) {
              this.allies = result.data.filter(f => f.enable_for_payment == 1)
            }
          })
        axios.get('/api/enrollments')
          .then(result => {
            if (result.status === 200) {
              this.enrollments = result.data
            }
          })
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/alliesPaymentsReport.vue